export default __webpack_public_path__ + "static/individuals-1-650f6585cdaeabe09c6000c1f089f9f4.jpg";